import { withStore } from 'store';
import { withLayout } from 'hocs';
import {
  fetchExternalGiftTableProducts,
  addShoppingCartProduct,
  removeShoppingCartProduct,
  fetchShoppingCart,
  changeProductsPage,
  createShoppingCart,
} from 'store/actions/externalGiftTable';
import RsvptLanding from './RsvptLanding';

const actions = {
  fetchExternalGiftTableProducts,
  addShoppingCartProduct,
  removeShoppingCartProduct,
  fetchShoppingCart,
  changeProductsPage,
  createShoppingCart,
};

export default withLayout(
  withStore(
    {
      mapStateToProps: (state) => ({
        tableInfo: state.giftTable.giftTable
      }),
    },
    actions
  )(RsvptLanding)
);
